import React, { useEffect, useState } from 'react';
import '../../css/nftDetailModal.css';
import close_btn from '../../assets/close.svg';
import axios from 'axios';
import Loading from '../Loading';
import filterBtn from '../../assets/filter-arrow.svg';
import checkImg from '../../assets/check.png';
import shareImg from '../../assets/share.png';
import aboutIcon from '../../assets/aboutIcon.png';
import toggleIcon from '../../assets/toggleIcon.png';
import nftAboutIcon from '../../assets/nftAboutMenu.png';
import { translatedText } from '../../recoil-states/language-state';
import { useRecoilValue } from 'recoil';
import cardImg from '../../assets/hyatt_vip_card.png';
import { motion } from 'framer-motion';

const ProductPackage = ({ itemData, setOpenMystery, view = true }) => {
	let detailData;
	const [nftData, setNftData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [openAbout, setOpenAbout] = useState(true);
	const [openDes, setOpenDes] = useState(true);
	const textData = useRecoilValue(translatedText);
	const nftDataLogo = textData.story.carousel_duman;
	const [nftDetailData, setNftDetailData] = useState([]);

	useEffect(() => {
		document.body.style.overflow = 'hidden';

		return () => {
			document.body.style.overflow = 'unset';
		};
	}, []);

	const onCloseModal = e => {
		if (e.target.id === 'mystery_gallery_modal') {
			setOpenMystery(false);
		}
	};

	const goOpenSea = () => {
		window.open(
			`https://opensea.io/assets/ethereum/0x8db7af4c6420d6c9ad881d91259970a61143773b/${itemData.id}`
		);
	};

	return (
		<div
			className='nft_detail_modal'
			id='mystery_gallery_modal'
			onClick={onCloseModal}
		>
			<motion.div
				className='nft_detail_modal_container'
				initial={{
					opacity: 0,
					scale: 0.75,
				}}
				animate={{
					opacity: 1,
					scale: 1,
					transition: {
						ease: 'easeOut',
						duration: 0.15,
					},
				}}
				exit={{
					opacity: 0,
					scale: 0.75,
					transition: {
						ease: 'easeIn',
						duration: 0.15,
					},
				}}
			>
				<div className='nft_box_container'>
					<div
						className='close_btn_svg'
						onClick={() => setOpenMystery(false)}
						style={{ cursor: 'pointer' }}
					>
						<img src={close_btn} />
					</div>
					<div className='hyatt_card_img'>
						<div className='hyatt_card_background'>
							<img
								src={require(`../../assets/${itemData.type}/${itemData.image}.png`)}
								style={{ width: '100%', borderRadius: '10px' }}
							/>
						</div>
					</div>
					<div className='konnect_text'>
						<h3>
							Konnect World
							<img src={checkImg} />
						</h3>
						<p>
							Owned by <span>Konnect</span>
							<img src={shareImg} />
						</p>
					</div>
					<div className='nft_detail_text_box'>
						<div className='text_box_left'>
							<h1>Konnect</h1>
							<h1>Product Card</h1>
						</div>
						<div className='text_box_right'>
							<p>#001</p>
						</div>
					</div>
					<div className='nft_about_box'>
						<div
							className='nft_about_top'
							style={{ borderRadius: !openAbout ? '10px' : null }}
							onClick={() => setOpenAbout(!openAbout)}
						>
							<div className='nft_about_box_left'>
								<img src={aboutIcon} />
								<h1>About Konnect 1st MysteryBox Event</h1>
							</div>
							<div className='nft_about_box_right'>
								<img
									src={toggleIcon}
									style={{
										transform: openAbout
											? 'rotate(0deg)'
											: 'rotate(180deg)',
									}}
								/>
							</div>
						</div>
						<div
							className='nft_about_content'
							aria-expanded={!openAbout}
						>
							<p>{textData.description.product}</p>
						</div>
					</div>
					<div className='nft_about_box'>
						<div
							className='nft_about_top'
							style={{ borderRadius: !openDes ? '10px' : null }}
							onClick={() => setOpenDes(!openDes)}
						>
							<div className='nft_about_box_left'>
								<img src={nftAboutIcon} />
								<h1>Description</h1>
							</div>
							<div className='nft_about_box_right'>
								<img
									src={toggleIcon}
									style={{
										transform: openDes
											? 'rotate(0deg)'
											: 'rotate(180deg)',
									}}
								/>
							</div>
						</div>
						<div
							className='nft_about_content_bottom'
							aria-expanded={!openDes}
						>
							<p>KONNECT Product NFT</p>
						</div>
					</div>
					{/* <div className='opensea_btn'>
                        <button onClick={goOpenSea}>OPENSEA에서 보기</button>
                    </div> */}
					{view ? (
						<div className='detail_modal_btn_container'>
							<div className='detail_modal_btn_top'>
								<button className='clasic_button'>
									멤버쉽 정보 보기
								</button>
								<button className='clasic_button'>
									My Wallet으로 이동
								</button>
							</div>
							<div className='detail_modal_btn_bottom'>
								<button className='activity_button_full'>
									예약하기
								</button>
							</div>
						</div>
					) : null}
				</div>
			</motion.div>
		</div>
	);
};

export default ProductPackage;
